import { Service, service } from './di'
import { Favourites } from './FavouriteService'

@service
export class EventService extends Service {
    fireAuthEvent(action: string, msg?: string, target?: EventTarget): void {
        const node = target || window
        node.dispatchEvent(
            new CustomEvent('flipp-auth', {
                cancelable: true,
                bubbles: true,
                detail: {
                    action,
                    message: msg,
                },
            })
        )
    }

    fireClippingsChangedEvent(target?: EventTarget) {
        const node = target || window
        node.dispatchEvent(
            new Event('flipp-clippingschanged', {
                cancelable: true,
                bubbles: true,
            })
        )
    }

    fireCouponClippedEvent(
        couponId: number,
        context: string,
        action: string,
        target?: EventTarget
    ) {
        const node = target || window
        node.dispatchEvent(
            new CustomEvent('flipp-couponclipped', {
                cancelable: true,
                bubbles: true,
                detail: {
                    couponId,
                    context,
                    action,
                },
            })
        )
    }

    fireLoyaltyCardEvent(
        action: string,
        programId: number,
        target?: EventTarget,
        preventProxy?: boolean
    ) {
        const node = target || window
        const evt = new CustomEvent('flipp-loyaltycards', {
            cancelable: true,
            bubbles: true,
            detail: {
                action,
                programId,
            },
        })
        if (preventProxy) evt.preventDefault()
        node.dispatchEvent(evt)
    }

    fireDialogCloseEvent(target?: EventTarget) {
        const node = target || window
        node.dispatchEvent(
            new Event('flipp-dialog-close', {
                bubbles: true,
                cancelable: false,
            })
        )
    }

    fireShoppingListEvent(type: string, target?: EventTarget) {
        const node = target || window
        node.dispatchEvent(
            new CustomEvent('flipp-shopping-list', {
                cancelable: true,
                bubbles: true,
                detail: {
                    type,
                },
            })
        )
    }

    fireFavouritesEvent(type: string, data: Favourites, target?: EventTarget) {
        const node = target || window
        node.dispatchEvent(
            new CustomEvent('flipp-favourites', {
                cancelable: true,
                bubbles: true,
                detail: {
                    type,
                    data,
                },
            })
        )
    }

    fireAnalyticsEvent(type: string, target?: EventTarget) {
        const node = target || window
        node.dispatchEvent(
            new CustomEvent('flipp-analytics', {
                cancelable: true,
                bubbles: true,
                detail: {
                    type,
                },
            })
        )
    }

    showModalInForm(target?: EventTarget) {
        const node = target || window
        node.dispatchEvent(
            new CustomEvent('show-modal-form', {
                cancelable: false,
                bubbles: true,
            })
        )
    }

    redirectToForm(target?: EventTarget) {
        const node = target || window
        node.dispatchEvent(
            new CustomEvent('redirect-to-form', {
                cancelable: false,
                bubbles: true,
            })
        )
    }

    changeUserLocationForm(target?: EventTarget) {
        const node = target || window
        node.dispatchEvent(
            new CustomEvent('redirect-from-form', {
                cancelable: false,
                bubbles: true,
            })
        )
    }

    unsubscribeFromRedirect(target?: EventTarget) {
        const node = target || window
        node.dispatchEvent(
            new CustomEvent('unsubscribe-from-redirect', {
                cancelable: false,
                bubbles: true,
            })
        )
    }

    redirectWhenLogoutInForm(target?: EventTarget) {
        const node = target || window
        node.dispatchEvent(
            new CustomEvent('redirect-logout-form', {
                cancelable: false,
                bubbles: true,
            })
        )
    }

    mobileBannerClosed(target?: EventTarget) {
        const node = target || window
        node.dispatchEvent(
            new CustomEvent('mobile-banner-closed', {
                cancelable: false,
                bubbles: true,
            })
        )
    }

    closePopupInSearch() {
        window.dispatchEvent(
            new CustomEvent('close-popup-search', {
                cancelable: false,
                bubbles: true,
            })
        )
    }

    displayMobilePopupBanner() {
        window.dispatchEvent(
            new CustomEvent('display-mobile-popup-banner', {
                cancelable: false,
                bubbles: true,
            })
        )
    }

    displayAddedItemPopup(count: number = 1) {
        window.dispatchEvent(
            new CustomEvent('flipp-item-added', {
                cancelable: false,
                bubbles: true,
                detail: {
                    count,
                },
            })
        )
    }

    displayRemoveItemPopup() {
        window.dispatchEvent(
            new CustomEvent('flipp-item-removed', {
                cancelable: false,
                bubbles: true,
            })
        )
    }

    adLoaded(adZoneAdAvailabilityMap: any) {
        window.dispatchEvent(
            new CustomEvent('flipp-ad-loaded', {
                cancelable: false,
                bubbles: true,
                detail: {
                    adZoneAdAvailabilityMap,
                },
            })
        )
    }

    displayInfoPopup(id: string) {
        window.dispatchEvent(
            new CustomEvent('display-info-popup', {
                cancelable: false,
                bubbles: true,
                detail: {
                    id,
                },
            })
        )
    }
}
